import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();

    console.log("🔒 Checking user in ProtectedRoute:", user);

    if (user === undefined) {
        console.log("⏳ Waiting for user state...");
        return <div>Loading...</div>;  // Prevents redirect loop
    }

    return user ? children : <Navigate to="/login" />;
}
